import cx from 'clsx';
import dayjs from 'dayjs';

import ColorTag from '~/components/ColorTag';
import type { OAISchema } from '~/types/openapi';

import CouponMembershipBadge from './CouponMembershipBadge';

type Props = {
  coupon: OAISchema['MarketBuyerCouponResponse'];
  className?: string;
};

const CouponBadges = ({ coupon, className }: Props) => {
  return (
    <div className={cx('flex gap-6 mb-6', className)}>
      {coupon.isPlusMembershipCoupon && <CouponMembershipBadge />}
      {Boolean(coupon.expirationAt) && (
        <ColorTag
          label={`${dayjs(coupon.expirationAt).format('YYYY-MM-DD')}까지`}
          color="red"
        />
      )}
    </div>
  );
};

export default CouponBadges;
